<template>
  <div>
    <el-button
      icon="el-icon-plus"
      type="primary"
      rounded
      @click="dialogVisible = true"
    >Publish Discussion</el-button>

    <DiscussionRecordList :discussion-list="discussionList" @refresh-list="refreshList" />
    <DiscussionPublishForm :dialogVisible.sync="dialogVisible" @refresh-list="refreshList" />
  </div>
</template>

<script>
import DiscussionRecordList from "@/components/DiscussionRecordList";
import DiscussionPublishForm from "@/components/DiscussionPublishForm";
import { getDiscussionListByClass } from "@/api";
import moment from 'moment';

export default {
  name: "Discussion",
  components: {
    DiscussionRecordList,
    DiscussionPublishForm
  },
  data() {
    return {
      discussionList: [],
      dialogVisible: false
    };
  },
  mounted() {
    this.getDiscussionList();
  },
  methods: {
    refreshList() {
      this.getDiscussionList();
    },
    getDiscussionList() {
      getDiscussionListByClass(this.$route.params.class_id).then(res => {
         this.discussionList = res.map((item, index) => ({
          index,
          ...item,
          release_time: moment(item.release_time).format("MMM Do, YYYY, HH:mm")
        }));
      })
    }
  }
};
</script>

<style scoped>
</style>